interface Post {
  id: number;
  text: string;
  image: string | undefined;
  video: string | undefined;
  data: [{ value: string | undefined }]; // title
  url: string;
}

type ErrorObj = {
  status: number;
  message: string;
  response: string;
};

type State = 'INIT' | 'LOADING' | 'RESULTS' | 'ERROR';

export default function useSocialMediaPosts() {
  const posts = ref<Post[]>([]);
  const error = ref<ErrorObj | null>(null);
  const state: Ref<State> = ref('INIT');

  const fetchPosts = async (feedPublicKey: string): Promise<Post[]> => {
    try {
      const path = 'https://api.curator.io/v1/feeds/';
      const limit = 4; // Limit set to 4 posts
      const status = 1; // Fetch only active posts
      state.value = 'LOADING';

      const response = await fetch(
        `${path}${feedPublicKey}/posts?limit=${limit}&status=${status}`,
      );
      const data = await response.json();
      posts.value = data.posts;

      state.value = 'RESULTS';
      if (posts.value.length === 0) {
        state.value = 'ERROR';
      }
      return posts.value;
    } catch (err) {
      const errObj: ErrorObj = {
        status: 404,
        message:
          'Error fetching posts from Curator API. Check public feed key.',
        response: (err as Error).message,
      };
      error.value = errObj;
      state.value = 'ERROR';
      throw errObj;
    }
  };

  return {
    state,
    posts,
    error,
    fetchPosts,
  };
}
